import React, { PropsWithChildren } from 'react';

type Props = {
  isShowing: boolean;
  hide: () => void;
  autoHeight?: boolean;
  className?: string;
};

// Inspired by https://upmostly.com/tutorials/modal-components-react-custom-hooks
const LiquidityModal: React.FC<Props & PropsWithChildren> = (props) => {
  if (!props.isShowing) return null;

  return (
    <>
      {/* Modal Overlay */}
      <div className="fixed top-0 left-0 z-[1040] w-screen h-screen bg-black/50 backdrop-blur-sm " />
      <div
        className="fixed top-0 left-0 z-[1050] w-full h-full overflow-hidden"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="flex flex-col relative rounded-[10px] overflow-hidden max-w-[600px] inner-box-bg-color inner-box-shadow mt-10 tablet:mt-40 ml-auto mr-auto  primary-text-color">
          {props.children}
        </div>
      </div>
    </>
  );
};

export default LiquidityModal;
